import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]

import "./ModalLayout.scss";
import Footer from "@/components/Footer/Footer.vue";
import Menu from "@/components/Menu/Menu.vue";
import Header from "@/components/Header/Header.vue";
import Icon from "@/components/Icon/Icon.vue";

interface Props{
	title : string,
	back? : string | boolean | Function
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalLayout',
  props: {
    title: {},
    back: { type: [String, Boolean, Function], default: false }
  },
  setup(__props: any) {

let props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, {
      title: _unref(props).title,
      class: "modal-header",
      back: _unref(props).back
    }, {
      right: _withCtx(({goBack}) => [
        _createElementVNode("button", {
          class: "modal-header__close",
          onClick: goBack,
          type: "button"
        }, [
          _createVNode(Icon, { name: "close" })
        ], 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["title", "back"]),
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(Footer),
    _createVNode(Menu)
  ], 64))
}
}

})